import React from "react"
export default function VideoCall() {
    return (
        <p>Chat..  </p>
    )
}